<div class="app-content content">
    <div class="content-wrapper">
      <div class="content-header row mb-1">
        <app-breadcrumb class="col-12" [breadcrumb]="breadcrumb"></app-breadcrumb>
        <p class="col-12"><span><h4 class="text-bold-500 blue4">Da clic a una empresa y accede a sus detalles</h4></span></p>
      </div>
      <div class="content-body" *ngIf="response">
        <section id="list-empresas-afiliadas">
          <div class="col-md-12">
            <div *ngIf="!response?.data">
              <div class="bs-callout-info callout-round callout-bordered mt-1">
                <div class="media align-items-stretch">
                  <div class="d-flex align-items-center media-left media-middle bg-info callout-arrow-left position-relative p-2">
                    <i class="la la-ban white font-medium-5"></i>
                  </div>
                  <div class="media-body p-1">
                    <h4 class="info">No se han registrado empresas</h4>
                    <p>Todavía no hay registro de empresas que hayan creado un perfil para colaborar, por lo que no hay información que mostrar.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div *ngIf="response?.data">
              <div class="col-md-12" *ngFor="let empresa of response?.data;">
                <a href="javascript:void(0)" class="card-link" (click)="openDetail(empresa)">
                  <div class="card pull-up">
                    <div class="card-content">
                      <div class="media align-items-stretch">
                        <div class="media-middle">
                          <div class="p-1 media-middle rounded-left">
                              <img *ngIf="empresa?.imgUrl=='' || !empresa?.imgUrl" src="https://res.cloudinary.com/drtcnv1st/image/upload/v1678230926/Empresa/perfil-emp_an8une.png" style="width: 60px; height: 60px;">
                              <img *ngIf="empresa?.imgUrl!=null" src="https://res.cloudinary.com/drtcnv1st/image/upload/v1677859035/Empresa/{{empresa.imgUrl}}" style="width: 60px; height: 60px;">
                          </div>
                        </div>
                        <div class="media-body p-1">
                          <h3 class="blue4 text-bold-600">{{ empresa.nombreEmpresa }}</h3>
                          <h4>{{ empresa.domicilioFiscal }}</h4>
                        </div>
                      </div>
                    </div>
                  </div>
                </a>
              </div>
            </div>
          </div>

          <div class="d-flex justify-content-between p-2" *ngIf="response?.totalPages > 1">
            <div class="col-lg-6 col-md-12">
              <nav aria-label="Navegador de páginas">
                <ul class="pagination justify-content-star pagination-separate ">
                  <ngb-pagination 
                  [(page)]="currentPage" 
                  [collectionSize]="response?.totalRows" 
                  [pageSize]="response?.pageSize" 
                  (pageChange)="pageChange($event)"
                  class="d-flex justify-content-start"></ngb-pagination>
                </ul>
              </nav>              
            </div>
          </div>
        </section>
        <div class="p-2 mt-2"></div>
        <div class="p-2 mt-2"></div>
      </div>
    </div> 
  </div>
